import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from "react-redux";

import ListV2 from '../../../../content/list/ListV2';
import useGetOne from '../../../../../../hooks/useGetOne';

function ConnectedTracks({ pathApi, width, height }) {
  const api = useSelector( state => state.api);
  const { item } = useGetOne(api, pathApi, null);

  return (item && item.count > 0) ? (
    <ListV2
      pathApi={pathApi}
      loadMoreWithApi={false}
      sortable={false}
      id={`my-beatport`}
      width={width}
      height={height - (Config.TAB_BAR_GUTTER * 5.8)}
      size={Config.LIST_ROW_HEIGHT}
      style={{paddingTop: 12}}
      isLoadMore={true}
      type={`Full`}
      orderBy={[`release`, `title`, `label`, `genre_s`, `artists_s`] /* API - `key_camelot`, `bpm` NOT WORKING */}
      filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key_convert`, `publish_date`, `preorders`] }
      filtersStyle={{position: `absolute`, top: 20, right: 127}}
      panelStyle={{ margin: `0px 0px 16px 0px` }}
      automix={true}
      automixName={`My Beatport`}
      automixStyle={{ position: `absolute`, top: 21, left: `auto`, right: 0 }}
      from={`/my-beatport`}
    />
  ) : ( (item && item.count === 0)
    ? <span className={'type-placeholder'} style={{marginTop: 16, position: 'absolute'}}>Follow your favorite artists and labels to start a feed of new releases.</span>
    : null
  )
}

ConnectedTracks.propTypes = {
  pathApi: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.any
}

const Tracks = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height
  })
)(ConnectedTracks);

export default Tracks;
